import { createAction, createSlice } from "@reduxjs/toolkit";
import { setCurrentUserColorOnDoc } from "../components/utils/misc";
// import { apiCallBegan } from "./apiActions";
// import { apiEndpoints } from "../api";

import userService from "../services/userService";

let defaultColor = { id: Date.now().toString(16), primary: "#16b0cf", secondary: "#6ebfb5" };

//%-<<*----------  NEEDED ENDPOINTS FOR THIS PARTICULAR REDUCER  ----------*>>-%//

// const { registerEndpoint, loginEndpoint, logoutEndpoint, authEndpoint } = apiEndpoints;

//%-<<*----------  REDUCERS AND ACTION TYPES  ----------*>>-%//

const userSlice = createSlice({
    name: "user",
    initialState: {
        currentUser: null,
        authErrorMessage: "",
        users: [],
        currentUserColors: [],
        loading: false,
    },

    reducers: {
        // LOGIN_USER: (user, { payload }) => ({ ...user, ...payload }),

        START_LOADING: messages => {
            messages.loading = true;
        },

        REGISTER_USER: (user, { payload }) => {
            payload?.authError
                ? Object.assign(user, { authErrorMessage: payload.errorMessage, currentUser: null, loading: false })
                : Object.assign(user, { authErrorMessage: "", currentUser: payload, loading: false });
        },

        LOGIN_USER: (user, { payload }) => {
            payload?.authError
                ? Object.assign(user, { authErrorMessage: payload.errorMessage, currentUser: null, loading: false })
                : Object.assign(user, { authErrorMessage: "", currentUser: payload, loading: false });
        },

        LOGOUT_USER: (user, { payload }) => {
            Object.assign(user, {
                currentUser: null,
                authErrorMessage: "",
                users: [],
                currentUserColors: [],
                loading: false,
            });

            setCurrentUserColorOnDoc(defaultColor);
        },

        INIT_CURRENT_USER: (user, { payload }) => {
            user.currentUser = payload;
        },

        GET_USERS: (user, { payload }) => {
            Object.assign(user, { users: payload, authErrorMessage: "", loading: false });
        },

        UPDATE_USERS_STATUS: (user, { payload }) => {
            Object.assign(user, { users: payload, authErrorMessage: "", loading: false });
        },

        SET_USER_FAVORITE_COLOR: (user, { payload }) => {
            user.currentUserColors.push(payload);

            setCurrentUserColorOnDoc(payload);
        },

        REMOVE_USER_FAVORITE_COLOR: (user, { payload }) => {
            user.currentUserColors = user.currentUserColors.filter(({ id }) => id !== payload.id);

            let docColorId = document.documentElement.style.getPropertyValue("--color-id");

            if (payload.id === docColorId) setCurrentUserColorOnDoc(user.currentUserColors[0] || defaultColor);
        },

        GET_USER_FAVORITE_COLORS: (user, { payload }) => {
            if (payload.length) {
                user.currentUserColors = payload;

                setCurrentUserColorOnDoc(payload[Math.floor(Math.random() * payload.length)]);
            }
        },

        CHANGE_CURRENT_USER_AVATAR: (user, { payload }) => {},
    },
});

export default userSlice.reducer;

//%-<<*----------  ACTIONS TYPES  ----------*>>-%//

const {
    START_LOADING,
    REGISTER_USER,
    LOGIN_USER,
    LOGOUT_USER,
    INIT_CURRENT_USER,
    GET_USERS,
    UPDATE_USERS_STATUS,
    SET_USER_FAVORITE_COLOR,
    REMOVE_USER_FAVORITE_COLOR,
    GET_USER_FAVORITE_COLORS,
    CHANGE_CURRENT_USER_AVATAR,
} = userSlice.actions;

//%-<<*----------  API USER ACTIONS  ----------*>>-%//

// export const registerUser = async ({ email, password }) => ({
//     type: REGISTER_USER.type,
//     payload: await firebase.auth().createUserWithEmailAndPassword(email, password),
// });

// export const registerUser = ({ email, password }) =>
//     apiCallBegan({
//         apiAction: firebase.auth().createUserWithEmailAndPassword(email, password),
//         onSuccess: REGISTER_USER.type,
//     });

// export const registerUser = async ({ email, password }) => {
//     const user = await firebase.auth().createUserWithEmailAndPassword(email, password);

// createAction(REGISTER_USER.type, user);

// };

// export const registerUser = async ({ email, password }) =>
//     createAsyncThunk(REGISTER_USER.type, await firebase.auth().createUserWithEmailAndPassword(email, password));

// export const registerUser = payload => createAction(REGISTER_USER.type, payload);

export const registerUser = data => async dispatch => {
    dispatch({ type: LOGOUT_USER.type });
    dispatch({ type: START_LOADING.type });

    try {
        dispatch({ type: REGISTER_USER.type, payload: await userService.registerUser(data) });
    } catch ({ message: errorMessage }) {
        dispatch({ type: REGISTER_USER.type, payload: { authError: true, errorMessage } });
    }
};

export const loginUser = data => async dispatch => {
    dispatch({ type: LOGOUT_USER.type });
    dispatch({ type: START_LOADING.type });

    try {
        dispatch({ type: LOGIN_USER.type, payload: await userService.loginUser(data) });
    } catch ({ message }) {
        dispatch({
            type: LOGIN_USER.type,
            payload: {
                authError: true,
                errorMessage: message.includes("password") ? "password or email is wrong!" : "user is not registered",
            },
        });
    }
};

export const logoutUser = () => async dispatch => {
    await userService.logoutUser();

    dispatch({ type: LOGOUT_USER.type });
};

export const initCurrentUser = payload => dispatch => dispatch({ type: INIT_CURRENT_USER.type, payload });

export const getUsers = () => async dispatch => {
    dispatch({ type: START_LOADING.type });

    dispatch({ type: GET_USERS.type, payload: await userService.getUsers() });
};

export const updateUsersStatus = createAction(UPDATE_USERS_STATUS.type);

export const setCurrentUserFavoriteColor = color => async dispatch => {
    dispatch({ type: SET_USER_FAVORITE_COLOR.type, payload: await userService.setCurrentUserFavoriteColor(color) });
};

export const removeCurrentUserFavoriteColor = id => async dispatch => {
    dispatch({ type: REMOVE_USER_FAVORITE_COLOR.type, payload: await userService.removeCurrentUserFavoriteColor(id) });
};

export const getCurrentUserFavoriteColors = () => async dispatch => {
    dispatch({ type: GET_USER_FAVORITE_COLORS.type, payload: await userService.getCurrentUserFavoriteColors() });
};

export const changeCurrentUserAvatar = (newAvatar, storageDir) => async dispatch => {
    dispatch({
        type: CHANGE_CURRENT_USER_AVATAR.type,
        payload: await userService.changeCurrentUserAvatar(newAvatar, storageDir),
    });
};
